import { Drop, FirstAid, Tag, Scan, PottedPlant, PlayCircle, DotsThree } from "@phosphor-icons/react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "./ui/dropdown-menu";

const MORE = [
  { key: "scan", label: "Scan a label", Icon: Scan },
  { key: "acute", label: "Acute event", Icon: FirstAid, color: "#FF3B30" },
  { key: "labels", label: "Labels", Icon: Tag },
  { key: "tour", label: "Take the tour", Icon: PlayCircle, testid: "open-tour-btn" },
];
const BTN = "h-10 px-4 max-[359px]:px-3 rounded-full inline-flex items-center justify-center gap-2 text-sm font-medium shrink-0 whitespace-nowrap transition-[background-color,transform,box-shadow] duration-200 active:scale-[0.96] focus-visible:ring-2 focus-visible:ring-primary focus-visible:outline-none";

export function MoreMenu({ onAction, items = MORE }) {
  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild>
        <button type="button" data-testid="quick-action-more" aria-label="More actions" className={`${BTN} pl-3.5 pr-4 text-muted-foreground hover:text-foreground bg-secondary/60 hover:bg-secondary data-[state=open]:bg-secondary data-[state=open]:text-foreground`}>
          <DotsThree weight="bold" className="h-[18px] w-[18px]" />More
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" sideOffset={8} collisionPadding={16} className="rounded-2xl w-56 max-w-[calc(100vw-2rem)] p-1.5" data-testid="quick-action-more-menu">
        {items.map(({ key, label, Icon, color, testid }) => (
          <DropdownMenuItem key={key} onClick={(e) => onAction(key, e)} data-testid={testid || `quick-action-${key}`} className="h-11 rounded-xl px-3 gap-3 text-[15px] cursor-pointer" style={color ? { color } : undefined}>
            <Icon weight={key === "acute" ? "bold" : "regular"} className="h-[18px] w-[18px] shrink-0" />{label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

export function QuickActions({ onAction }) {
  return (
    <div className="flex items-center gap-2" data-testid="quick-actions">
      <button type="button" onClick={(e) => onAction("care", e)} data-testid="quick-action-care"
        className={`${BTN} bg-[#0A84FF] text-white hover:bg-[#0071E3] shadow-sm hover:shadow-[0_8px_18px_-10px_rgba(10,132,255,0.9)]`}>
        <Drop weight="fill" className="h-[18px] w-[18px] max-[359px]:hidden" />Add care
      </button>
      <button type="button" onClick={(e) => onAction("plant", e)} data-testid="quick-action-plant"
        className={`${BTN} text-[#30A14E] bg-[#30A14E]/[0.06] ring-1 ring-inset ring-[#30A14E]/40 hover:bg-[#30A14E]/[0.14] hover:ring-[#30A14E]/60`}>
        <PottedPlant weight="fill" className="h-[18px] w-[18px] max-[359px]:hidden" />New plant
      </button>
      <MoreMenu onAction={onAction} />
    </div>
  );
}
